import { render, staticRenderFns } from "./vTitle.vue?vue&type=template&id=797a1871&scoped=true&"
import script from "./vTitle.vue?vue&type=script&lang=js&"
export * from "./vTitle.vue?vue&type=script&lang=js&"
import style0 from "./vTitle.vue?vue&type=style&index=0&id=797a1871&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a1871",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797a1871')) {
      api.createRecord('797a1871', component.options)
    } else {
      api.reload('797a1871', component.options)
    }
    module.hot.accept("./vTitle.vue?vue&type=template&id=797a1871&scoped=true&", function () {
      api.rerender('797a1871', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/vTitle.vue"
export default component.exports